












import { mapGetters } from 'vuex';

import { ROUTER_CONSTS } from '../router/router.consts';

import { CONFIG_CONSTS } from '../store/config/config.consts';

export default {
  name: 'page-not-found',
  data: function () {
    return {
      ROUTER_CONSTS
    };
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instance: CONFIG_CONSTS.getters.currentInstance
    }),
    redirectToInstance: function () {
      return {
        homeUrl: `<a href="${ this.instance ? `/${ this.instance.instanceId }`
          : '/' }">${ this.$epb.messages.app.pageNotFound.homepage }</a>`
      };
    }
  }
};

